import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import VerifyOtp from './VerifyOtp'
import { doShowToast, doHideToast } from 'Store/actions/toast'
import { nullSafe } from 'Utility/globalMethods'
import { doVerifyOtp, doRegenerateOtp, doResetState } from 'Store/actions/sca'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ doShowToast, doHideToast }, dispatch),
  doVerifyOtp: (payload) => dispatch(doVerifyOtp(payload)),
  doRegenerateOtp: (payload) => dispatch(doRegenerateOtp(payload)),
  doResetState: () => dispatch(doResetState())
})

const extractActionType = (action) => action.split('/').pop()

const mapStateToProps = (state) => ({
  isLoading: nullSafe(() => state.loading.localLoading[nullSafe(() => extractActionType(state.sca.nextAction.actionToInvoke), 'verify_otp')] || state.loading.localLoading.do_regenerate_otp, false),
  otpError: nullSafe(() => state.sca.error, ''),
  maskedPhoneFromPersistentData: nullSafe(() => state.sca.persistentData.maskedPhone, '')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}), { forwardRef: true })(VerifyOtp)
